import { AbstractHook } from '@hooks/abstraction';
import { CustomFieldService } from '../services/custom-field.service';
import { CustomFieldResponse } from '../services/responses/custom-field.response';

export class CustomFieldHook extends AbstractHook<CustomFieldResponse, CustomFieldService> {}
